import { render } from "./MyNotifications.vue?vue&type=template&id=a6e376b8&scoped=true"
import script from "./MyNotifications.vue?vue&type=script&lang=ts"
export * from "./MyNotifications.vue?vue&type=script&lang=ts"

import "./MyNotifications.vue?vue&type=style&index=0&id=a6e376b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a6e376b8"

export default script